/**
 * Simple ID Generation
 *
 * Generates short, random IDs for quizzes.
 * No need for content-based hashing since we're storing in IndexedDB.
 */

/**
 * Generate a short random ID (10 characters, URL-safe)
 * Format: alphanumeric, no ambiguous characters (0, O, I, l)
 */
export function generateShortId(): string {
  const alphabet = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
  const length = 10;
  let id = "";

  // Use crypto.getRandomValues for better randomness
  const randomValues = new Uint8Array(length);
  crypto.getRandomValues(randomValues);

  for (let i = 0; i < length; i++) {
    const char = alphabet[randomValues[i]! % alphabet.length];
    if (char) {
      id += char;
    }
  }

  return id;
}

/**
 * Generate a quiz ID with prefix
 */
export function generateQuizId(): string {
  return `qz_${generateShortId()}`;
}
